import { render } from "./ContactComp.vue?vue&type=template&id=aa848f5e&scoped=true&ts=true"
import script from "./ContactComp.vue?vue&type=script&lang=ts"
export * from "./ContactComp.vue?vue&type=script&lang=ts"

import "./ContactComp.vue?vue&type=style&index=0&id=aa848f5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa848f5e"]])

export default __exports__